import { useMe } from "./useMe";

export function TierBadge() {
  const { me } = useMe();
  if (!me) return null;
  const label = me.tier === "individual" ? "Pro" : "Free";
  const className = me.tier === "individual" ? "tier-badge tier-badge--paid" : "tier-badge tier-badge--free";
  return <span className={className}>{label}</span>;
}
